import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { Component, Input, OnInit } from '@angular/core';
import { HiringService } from 'src/app/pages/hiring/services/hiring.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { UtilityService } from '../../../core/services/utility.service';
import { SignalRService } from './../../../core/services/signal-r.service';
import { NgxCurrencyInputMode } from 'ngx-currency';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'app-onboard-init-modal',
  templateUrl: './onboard-init-modal.component.html',
  styleUrls: ['./onboard-init-modal.component.css']
})

export class OnboardInitModalComponent implements OnInit {
  @Input() personalInfoData: any;
  @Input() employee: any;
  @Input() employeeHRREFInfo: any;
  @Input() task: any;
  @Input() language: any;
  @Input() employeeList: any;
  @Input() expectHRRef: any;
  @Input() expectHRCo: any;
  format: string;
  portalSettings: any;
  employeeInfo: any;
  formData: { [key: string]: any } = {};
  datePickerOptions: { dateInputFormat: string; containerClass: string; showTodayButton: boolean; showClearButton: boolean; clearPosition: string; showWeekNumbers: boolean };
  mobileMode: boolean = false;
  deleteMode: boolean = false;
  taskDeleted: boolean = false;
  disableAttachmentUploadOnboarding: boolean = false;
  oNInitHirestoPayroll: boolean = false;
  autoAssignPREmpToHRRef: boolean = false;
  progressCurrent: any;
  currencySymbol: string;
  overtimeScheduleList: any[] = [];
  raceList: any[] = [];
  insuranceCodeList: any[] = [];
  timeRevList: any[] = [];
  prCompanies: any[] = [];
  hrCompanies: any[] = [];
  acaCode1: any[] = [];
  acaCode2: any[] = [];
  processed: boolean = false;
  processing: boolean = false;
  finishedLeave: boolean = false;
  pRGroups: any[] = [];
  employmentStatusList: any[] = [];
  localCodeList: any[] = [];
  crafts: any[] = [];
  classes: any[] = [];
  departments: any[] = [];
  earnCodes: any[] = [];
  occupationCat: any[] = [];
  positionCode: any[] = [];
  alert: { [key: string]: any } = { type: null, msg: null };
  options: { [key: string]: any } = {};

  constructor(public activeModal: NgbActiveModal, private modalService: NgbModal, portalSettingsService: PortalSettingsService, employeeInfoService: EmployeeInfoService, private hiringService: HiringService, private utilityService: UtilityService, private signalRService: SignalRService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
    this.format = utilityService.getDateFormat().toUpperCase();
    this.mobileMode = utilityService.isMobileMode();
    this.signalRService.establishHub('progressHub', 'sendProgressFileName');
  }

  ngOnInit(): void {
    //SignalR stuff
    this.signalRService.sendProgressFileNameEvent.subscribe((fileName: any) => {
      setTimeout(() => {
        this.progressCurrent = fileName;
      });
    });
    this.datePickerOptions = { dateInputFormat: this.format, containerClass: "theme-blue", showTodayButton: true, showClearButton: true, clearPosition: "left", showWeekNumbers: false };
    this.deleteMode = false;
    this.taskDeleted = false;
    this.formData.Gender = this.employee.Gender == "X" ? null : this.employee.Gender;
    this.formData.Race = this.employee.RaceEthnic;
    this.formData.autoRef = false;
    this.formData.hrefCB = false;
    this.formData.HRCo = { CompanyName: null, HRCo: null };
    this.formData.hrRef = null;
    this.formData.futureDate = false;
    this.formData.expectHRRef = this.expectHRRef;
    this.disableAttachmentUploadOnboarding = this.portalSettings.DisableAttachmentUploadOnboarding.ConfigValue == "1" ? true : false;
    this.oNInitHirestoPayroll = this.portalSettings.ONInitHirestoPayroll.ConfigValue == "1";
    this.autoAssignPREmpToHRRef = this.portalSettings.AutoAssignPREmpToHRRef.ConfigValue == "1";
    //241320: Race is mandatory field to fill out for Admin if Onboardee chosen 'I do not wish to answer' option.
    if (this.formData.Race == "X") {
      this.formData.Race = null;
    }
    this.formData.PREmployeeDisable = false;

    if (this.employee.IsRehire) {
      this.formData.PREmployeeDisable = true;
      this.formData.PREmployee = this.employeeHRREFInfo.PREmp;
    }

    if (this.oNInitHirestoPayroll && this.autoAssignPREmpToHRRef) {
      this.formData.PREmployeeDisable = true;
    }
    
    this.currencySymbol = this.utilityService.getCurrencySymbol(this.employeeInfo.PRCo);

    this.options = { align: 'left', prefix: this.currencySymbol, precision: 4, nullable: true, inputMode: NgxCurrencyInputMode.Natural };

    this.overtimeScheduleList = [{ Value: "N", Description: "None" }, { Value: "D", Description: "Daily" }, { Value: "W", Description: "Weekly" }
      , { Value: "C", Description: "Craft" }, { Value: "J", Description: "Job" }, { Value: "P", Description: "Posting Seq" }];

    if (this.personalInfoData != null && this.personalInfoData.AnticipHireDate != null) {
      this.formData.hireDate = cloneDeep(this.personalInfoData.AnticipHireDate);
    }
    this.getHRCo();
    this.getPRCo();
    this.getACA();
    this.getRaceCodes();
    this.getTimeRevGroup();

    if (this.employeeHRREFInfo != null) {
      if (this.employeeHRREFInfo.HRRef) {
        this.formData.hrRef = parseInt(this.employeeHRREFInfo.HRRef);
        this.formData.hrefCB = true;
      }
    } else {
      if (this.formData.expectHRRef != null) {
        this.formData.hrRef = this.formData.expectHRRef;
        this.formData.PREmployee = this.formData.hrRef;
      }
    }
  }

  ngOnDestroy(): void {
    // Stop SignalR connection to prevent multiple connections
    this.signalRService.stopConnection();
  }

  checkMaxLength() {
    if (this.oNInitHirestoPayroll && this.autoAssignPREmpToHRRef) {
      this.formData.PREmployee = this.formData.hrRef;
    }
    if (this.formData.hrRef.toString().length > 6)
      this.formData.hrRefDisable = true;
    else
      this.formData.hrRefDisable = false;
  }

  getRaceCodes() {
    this.hiringService.getRaceCodes().then((response: any) => {
      this.raceList = response;
      this.raceList.forEach((val: any) => {
        val.Race = val.Race.toString().trim();
      })

      if (this.formData.Race != null) {
        this.raceList.forEach((val: any) => {
          if (val.Race.toString().trim() == this.formData.Race.trim())
            this.formData.Race = val.Race.toString().trim();
        })
      }
      if (this.employee.IsRehire) {
        this.getRehireValues();
      }
    });
  }

  hrcoUpdate() {
    this.getEmploymentStatus();
    if (this.formData.PRCo == null) {
      this.prCompanies.forEach((val2: any) => {
        if (this.formData.HRCo.CompanyName == val2.PRCoNameMask) {
          this.formData.PRCo = val2.PRCo;
          this.pRCoChanged();
          return false;
        }
      });
    }
    this.formData.PositionCode = null;
    this.getPosition();
  }

  pRCoChanged() {
    this.formData.PRGroup = null;
    this.formData.Craft = null;
    this.formData.Class = null;
    this.formData.PRDept = null;
    this.formData.EarnCode = null;
    this.formData.InsCode = null;
    this.formData.LocalCode = null;
    this.formData.OccupCat = null;

    this.getDropDownValues();
  }

  craftChanged() {
    this.formData.Class = null;
    this.getClass();
  }

  hireDateChange() {
    if (this.formData.hireDate > new Date)
      this.formData.futureDate = true;
    else
      this.formData.futureDate = false;
  }

  //initialize get methods

  getHRCo() {
    this.hiringService.getHRCO().then((response: any) => {
      response.forEach((val: any) => {
        if (val.HRCo == this.expectHRCo) {
          this.formData.HRCo = val;
          this.getEmploymentStatus();
          this.getPosition();
        }
      });
      this.hrCompanies = response;
    });
  }

  getACA() {
    this.acaCode1 = [];
    this.acaCode2 = [];
    this.hiringService.getACACode().then((response: any) => {
      response.forEach((val: any) => {
        if (val.ComboType == "HRACACodeSeries1")
          this.acaCode1.push(val);
        else
          this.acaCode2.push(val);
      });
    });
  }

  getPRCo() {
    this.hiringService.getPRCo().then((response: any) => {
      this.prCompanies = response;
    });
  }

  getPRGroup() {
    var data = this.formData.PRCo;
    this.hiringService.getCompanyGroups(data).then((response: any) => {
      this.pRGroups = response;
    });
  }
 
  getInsurance() {
    this.hiringService.getInsCodes().then((response: any) => {
      this.insuranceCodeList = response;
      if (this.formData.InsCode != null) {
        var isExist = false;
        response.forEach((val: any) => {
          if (val.InsCode == this.formData.InsCode)
            isExist = true;
        })
        if (!isExist)
          this.formData.InsCode = null;
      }
      this.utilityService.closeModal();
    });
  }

  getTimeRevGroup() {
    this.hiringService.getInsCodes().then((response: any) => {
      this.timeRevList = response;
    });
  }

  getEmploymentStatus() {
    this.hiringService.getEmploymentStatus(this.formData.HRCo.HRCo).then((response: any) => {
      this.employmentStatusList = response;
    });
  }

  getLocalCode() {
    this.hiringService.getLocalCode(this.formData.PRCo).then((response: any) => {
      this.localCodeList = response;
    });
  }

  getCraft() {
    var data = this.formData.PRCo;
    this.hiringService.getCraft(data).then((response: any) => {
      this.crafts = response;
    });
  }

  getClass() {
    this.hiringService.getClass(this.formData.PRCo, encodeURIComponent(this.formData.Craft)).then((response: any) => {
      this.classes = response;
    });
  }

  getPRDept() {
    this.hiringService.getPRDept(this.formData.PRCo).then((response: any) => {
      this.departments = response;
    });
  }

  getEarnCode() {
    this.hiringService.getEarnCode(this.formData.PRCo).then((response: any) => {
      this.earnCodes = response;
    });
  }

  public getOccupation() {
    this.hiringService.getOccupationCategories(this.formData.PRCo).then((response: any) => {
      this.occupationCat = response;
    });
  }

  public getPosition() {
    this.hiringService.getPositionCodes(this.formData.HRCo.HRCo).then((response: any) => {
      this.positionCode = response;
    });
  }

  closeClicked() {
    if (this.finishedLeave)
      window.location.href = "/Hiring/OnboardingDashboard";
    else
      this.activeModal.close();
  }

  autoRefChange() {
    if (this.formData.autoRef) {
      this.formData.hrRef = null;
      this.formData.PREmployee = null;
    }
  }

  initialize() {
    var requestObj = { raceEthnic: null };
    if (this.formData.Race != null) {
      this.raceList.forEach((val: any) => {
        if (val.Race.trim() == this.formData.Race.trim())
          requestObj.raceEthnic = val.Race;
      })
    }
    this.processing = true;
    this.hiringService.initializeEmployee(this.employee.OnboardID, this.formData.HRCo.HRCo, moment(this.formData.hireDate).format("MM/DD/YYYY"), this.formData.hrRef, this.formData.PRCo,
      this.formData.PRGroup, this.formData.Craft, this.formData.Class, this.formData.PRDept, this.formData.EarnCode, this.formData.Gender, this.formData.Wage, requestObj.raceEthnic,
      this.formData.InsCode, this.formData.timesheetRevGroup, null, this.formData.CodeSeries1, this.formData.CodeSeries2, this.formData.EmploymentStatus, this.formData.LocalCode,
      this.formData.OvertimeSchedule, this.formData.PREmployee, this.formData.OccupCat, this.formData.PositionCode).then(async (response: any) => {
      if (response.success) {
        if (this.disableAttachmentUploadOnboarding) {
          this.alert = ({ type: "success", msg: this.employee.FirstName + " " + this.employee.LastName + " has been successfully initialized to HR Company " + this.formData.HRCo.HRCo + " with the Employee Number " + response.info[0].InitializedHRRef + (response.info[0].ReturnMessage != null ? (". " + response.info[0].ReturnMessage) : "") });
          this.processed = true;
          this.processing = false;
          this.finishedLeave = true;
        } else {
          await this.processOnboardingForms(response.info[0]);
        }

        if (response.info[0]['ReturnMessage']) {
          this.alert.msg += `\n\n${response.info[0]['ReturnMessage']}`;
        }

      } else {
        this.alert = { type: "danger", msg: response.error };
        this.finishedLeave = false;
        this.processed = true;
        this.processing = false;
      }
    }, (errorResponse: any) => {
      this.alert = { type: "danger", msg: errorResponse?.error?.error };
      this.finishedLeave = false;
      this.processed = true;
      this.processing = false;
    });
  }

  async processOnboardingForms(info: any) {
    var instanceIDs = [];
    var templateIDs = [];
    var filenames = [];
    var filetypes = [];
    if (this.task != null) {
      for (var i = 0; i < this.task.length; i++) {
        if (this.task[i].OnboardChecklistInstanceID != null) {
          instanceIDs.push(this.task[i].OnboardChecklistInstanceID);
          templateIDs.push(this.task[i].ChecklistTemplateID);
          filenames.push(this.task[i].Filename);
          filetypes.push("Checklist");
        }
        else if (this.task[i].OnboardBulletinID != null) {
          instanceIDs.push(this.task[i].OnboardBulletinID);
          templateIDs.push(-1);
          filenames.push(this.task[i].Filename);
          filetypes.push("Document");
        }
      }
    }

    const response: any = await this.hiringService.processOnboardingForms(info.HRRMKeyID, this.employee.OnboardID, instanceIDs, templateIDs, filenames, filetypes, this.employee.IncludeW4, this.employee.IncludeI9, this.employee.IncludeIdentification, this.language, this.employee.ApplicantOnboardID, this.employee.IncludeDirectDeposit, this.employee.IncludeEmergencyContacts,)
    if (response.success) {
      this.alert = ({ type: "success", msg: this.employee.FirstName + " " + this.employee.LastName + " has been successfully initialized to HR Company " + this.formData.HRCo.HRCo + " with the Employee Number " + info.InitializedHRRef });
      this.processed = true;
      this.processing = false;
      this.finishedLeave = true;
    } else {
      this.alert = { type: "danger", msg: response.errorMessage };
      this.finishedLeave = false;
      this.processed = true;
      this.processing = false;
    }
  }

  getDropDownValues() {
    this.utilityService.openModal();
    this.getPRGroup();
    this.getLocalCode();
    this.getCraft();
    this.getPRDept();
    this.getEarnCode();
    this.getInsurance();
    this.getOccupation();
  }

  getRehireValues() {
    this.utilityService.openModal();
    this.formData.HRCo = { HRCo: this.employeeHRREFInfo.HRCo, CompanyName: null };
    this.hiringService.getRehireDetailsByHRRef(this.employeeHRREFInfo.HRRef, this.employeeHRREFInfo.HRCo).then((response: any) => {
      var reHireInfo = response[0];
      this.formData.PRCo = reHireInfo.PRCo;
      if (reHireInfo.Race != null) {
        this.raceList.forEach((val: any) => {
          if (val.Race.toString().trim() == reHireInfo.Race.trim())
            this.formData.Race = val.Race.toString().trim();
        })
      }
      this.getDropDownValues();
      this.formData.Wage = reHireInfo.ExpectedSalary;
      this.formData.PRGroup = reHireInfo.PRGroup;
      this.formData.InsCode = reHireInfo.StdInsCode;
      this.formData.Craft = reHireInfo.StdCraft;
      if (this.formData.Craft) {
        this.getClass();
        this.formData.Class = reHireInfo.StdClass;
      }
      this.formData.PRDept = reHireInfo.PRDept;
      this.formData.EarnCode = reHireInfo.EarnCode;
      this.formData.OccupCat = reHireInfo.OccupCat;
      this.formData.PositionCode = reHireInfo.PositionCode;
      this.getEmploymentStatus();
      this.getPosition();
    });
  }

}
